import {http} from './../helpers/http-helper';
import {Consignment} from './../classes/consignment';
import {Receipt} from './../classes/receipt';

function createConsignmentFromResponse(response) {
    let receipts = Array.isArray(response.receipts)
        ? response.receipts.map((receipt) => {
            return new Receipt(
                receipt.uuid,
                receipt.consignment,
                receipt.member,
                new Date(receipt.createdAt),
                (!!response.issueDate ? new Date(response.issueDate) : null),
                receipt.amount,
                receipt.status,
                receipt.periodicity,
                receipt.type,
                receipt.code,
                response.memberCalled,
                (!!response.chargeFromDate ? new Date(response.chargeFromDate) : null),
                response.chargedBy,
                (!!response.chargedAt ? new Date(response.chargedAt) : null),
                response.receiptMemento
            );
        })
        : null;

    return new Consignment(
        response.uuid,
        response.createdBy,
        new Date(response.createdAt),
        response.code,
        response.type,
        new Date(response.issueDate),
        new Date(response.presentationDate),
        new Date(response.chargeDate),
        response.description,
        response.status,
        response.headquarters,
        response.periodicities,
        receipts,
        response.sepaXml,
        response.seatsDiary,
        response.seatsSubAccounts,
        response.bankAmount,
        response.collectorAmount,
        response.receiptAmount,
        response.totalAmount,
        response.numberReceipts
    )
}

export const createConsignment = (consignment) => {
    return new Promise((resolve, reject) => {
        const url = 'consignments';
        http.post(url, consignment)
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const addReceiptsToConsignment = (consignmentId, receiptsIds) => {
    return new Promise((resolve, reject) => {
        const url = 'consignments/' + consignmentId + '/receipts';
        http.post(url, {receiptsIds})
            .then((response) => {
                if (response.status === 200) {
                    resolve(createConsignmentFromResponse(response.data));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getConsignments = (searchData) => {
    return new Promise((resolve, reject) => {
        const url = 'consignments';
        http.get(url, searchData)
            .then((response) => {
                if (response.status === 200) {
                    let consignments = [];

                    response.data.consignments.forEach((consignment) => {
                        consignments.push(createConsignmentFromResponse(consignment));
                    });

                    resolve({
                        consignments: consignments,
                        count: response.data.count
                    });

                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getConsignment = (consignmentId) => {
    return new Promise((resolve, reject) => {
        const url = 'consignments/' + consignmentId;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(createConsignmentFromResponse(response.data));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const issueConsignment = (consignmentId) => {
    return new Promise((resolve, reject) => {
        const url = 'consignments/' + consignmentId + '/issue';
        http.post(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(createConsignmentFromResponse(response.data));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const issueConsignments = (consignmentsIds) => {
    return new Promise((resolve, reject) => {
        const url = 'consignments/issue';
        http.post(url, {consignmentsIds}, null, 'blob')
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const postConsignment = (consignmentId) => {
    return new Promise((resolve, reject) => {
        const url = 'consignments/' + consignmentId + '/post';
        http.post(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(createConsignmentFromResponse(response.data));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const postConsignments = (consignmentsIds) => {
    return new Promise((resolve, reject) => {
        const url = 'consignments/post';
        http.post(url, {consignmentsIds}, null, 'blob')
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getConsignmentSeatsFiles = (consignmentId) => {
    return new Promise((resolve, reject) => {
        const url = 'consignments/' + consignmentId + '/seats/download';
        http.get(url, {}, 'arraybuffer')
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteConsignment = (consignmentId) => {
    return new Promise((resolve, reject) => {
        const url = 'consignments/' + consignmentId;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteConsignments = (consignmentsIds) => {
    return new Promise((resolve, reject) => {
        const url = 'consignments/delete';
        http.post(url, {consignmentsIds}, null, 'blob')
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};